<template>
    <div class="lyworkflow-wrap">
		<div class="lyworkflow-wrap-box lyworkflow-wrap-box-lyInitiator start-node" @click="show">
			<div class="title" style="background: #163d47;">
				<el-icon class="icon"><user-filled /></el-icon>
				<span>{{ nodeConfig.nodeName }}</span>
			</div>
			<div class="content">
				<span>{{ toText(nodeConfig) }}</span>
			</div>
		</div>
		<lyAddNodes v-model="nodeConfig.childNode" :isDesign="isDesign"></lyAddNodes>
		<el-drawer title="发起人" v-model="drawer" destroy-on-close append-to-body size="40%" class="lyworkflow-drawer">
			<template #header>
				<div class="lyworkflow-wrap-drawer__title">
					<label @click="editTitle" v-if="!isEditTitle">{{form.nodeName}}<el-icon class="lyworkflow-wrap-drawer__title-edit"><Edit /></el-icon></label>
					<el-input v-if="isEditTitle" ref="nodeTitle" v-model="form.nodeName" clearable @blur="saveTitle" @keyup.enter="saveTitle"></el-input>
				</div>
			</template>
			<el-container>
				<el-main style="padding:0 20px 20px 20px">
					<el-form label-position="top">
						<el-form-item label="谁可以发起此审批">
							<el-select v-model="form.setType" @change="handleChange">
								<el-option :value="1" label="所有人"></el-option>
								<el-option :value="2" label="指定用户"></el-option>
								<el-option :value="3" label="指定角色"></el-option>
							</el-select>
						</el-form-item>
                        <el-form-item v-if="form.setType==2" label="选择成员">
							<el-button type="primary" icon="plus" round @click="selectHandle(1, form.nodeUserList)">选择人员</el-button>
							<div class="lyworkflow-tags-list">
								<el-tag v-for="(user, index) in form.nodeUserList" :key="user.id" closable @close="delUser(index)">{{user.name}}</el-tag>
							</div>
						</el-form-item>
                        <el-form-item v-if="form.setType==3" label="指定角色">
							<el-button type="primary" icon="plus" round @click="selectHandle(2, form.nodeRoleList)">选择角色</el-button>
							<div class="lyworkflow-tags-list">
								<el-tag v-for="(role, index) in form.nodeRoleList" :key="role.id" closable @close="delRole(index)">{{role.name}}</el-tag>
							</div>
						</el-form-item>
						<el-alert v-if="(form.nodeRoleList.length==0 && form.nodeUserList.length==0) && form.setType !=1" title="不指定则默认所有人都可发起此审批" type="info" :closable="false"/>
					</el-form>
				</el-main>
				<el-footer class="lyworkflow-drawer-footer">
					<el-button type="primary" @click="save">保存</el-button>
					<el-button @click="drawer=false">取消</el-button>
				</el-footer>
			</el-container>
		</el-drawer>
	</div>
</template>

<script setup>
    import { ref, onMounted, watch, computed , nextTick,inject} from 'vue'
    import lyAddNodes from "./lyAddNodes"

    const props = defineProps({
        modelValue: { type: Object, default: () => {}  },
        isDesign: { //是否设计模式
            type: Boolean,
            default: true
        }
    })

    const emits = defineEmits(['update:modelValue'])

    let nodeConfig = ref(props.modelValue)
    watch(()=>props.modelValue,()=>{
        nodeConfig.value = props.modelValue
    },{deep:true})
    // watch(()=>nodeConfig.value,()=>{
    //     emits("update:modelValue", nodeConfig.value)
    // },{deep:true})

    let form = ref({})
    let isEditTitle = ref(false)
    let drawer = ref(false)
    let nodeTitle = ref(null)
    const lySelectHandle = inject("lySelectHandle",null)

    function handleChange(e){
        if(e == 1){
            form.value.nodeRoleList = []
            form.value.nodeUserList = []
        }else if(e == 2){
            form.value.nodeRoleList = []
        }else if(e == 3){
            form.value.nodeUserList = []
        }
    }

    function show(){
        if(props.isDesign){
            form.value = {}
            form.value = JSON.parse(JSON.stringify(nodeConfig.value))
            isEditTitle.value = false
            drawer.value = true
        }
    }

    function editTitle(){
        isEditTitle.value = true
        nextTick(()=>{
            nodeTitle.value.focus()
        })
    }

    function saveTitle(){
		isEditTitle.value = false
	}

    function selectHandle(type, data){
        lySelectHandle(type, data)
    }

    function delUser(index){
        form.value.nodeUserList.splice(index, 1)
    }

    function delRole(index){
        form.value.nodeRoleList.splice(index, 1)
    }

    function save(){
        nodeConfig.value = form.value
        emits("update:modelValue", form.value)
		drawer.value = false
    }

    function toText(nodeConfig){
        if(nodeConfig.setType == 1){
            return "所有人"
        }else if(nodeConfig.setType == 3 && nodeConfig.nodeRoleList && nodeConfig.nodeRoleList.length > 0){
            const roles = nodeConfig.nodeRoleList.map(item=>item.name).join("、")
            return '角色-' + roles
        }else if(nodeConfig.setType == 2 && nodeConfig.nodeUserList && nodeConfig.nodeUserList.length>0) {
            const users = nodeConfig.nodeUserList.map(item=>item.name).join("、")
            return '用户-' + users
        }else{
            return "所有人"
        }
    }

</script>

<style scoped>
    
</style>